import { render, staticRenderFns } from "./MultiSelectBankKind.vue?vue&type=template&id=0da3c542"
import script from "./MultiSelectBankKind.vue?vue&type=script&lang=ts"
export * from "./MultiSelectBankKind.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da3c542')) {
      api.createRecord('0da3c542', component.options)
    } else {
      api.reload('0da3c542', component.options)
    }
    module.hot.accept("./MultiSelectBankKind.vue?vue&type=template&id=0da3c542", function () {
      api.rerender('0da3c542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/MultiSelectBankKind.vue"
export default component.exports